<template>
  <button class="qrbutton" :class="{ 'qrbutton-shadow': withShadow }">
    <slot />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  withShadow?: boolean;
}>();

</script>

<style lang="scss" scoped>
.qrbutton {

  background: white;
  color: $kw-global-textcolor;
  height: auto;
  min-height: 35px;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 22px;
  text-align: left;
  margin-left: 0px;
  margin-bottom: 0px;
  padding: 7px 10px;
  font-size: 1.5rem;

  @include default-font-small;

  &.qrbutton-shadow {
    filter: drop-shadow(0 0 10px $kw-default-shadow-color-light);
  }

  &:hover,
  &:focus {
    cursor: pointer;
    box-shadow: none;
    border-color: $kw-default-button-border-color-hover;
    transition: border-color 0.2s ease-in-out;
    color: var(--moin-quickreplybar-pill-textcolor-hover, $kw-global-textcolor);
    background: var(--moin-quickreplybar-pill-background-hover, $kw-global-background-white);
  }

  /* After above &:focus to overwrite collisions */
  @include default-focus-unknown-bg;
  &:focus-visible {
    border: none; /* Too many stripes with this */
  }

  @media (min-width: $kw-widget-breakpoint) {
    min-height: 35px;
    @include default-font-small;
    padding: 0 14px;
    margin-left: 4px;
    margin-bottom: 4px;
  }




}
</style>
